export const clerkProviderConfig = {
  afterSignOutUrl: "/sign-in",
  appearance: {
    variables: {
      colorPrimary: "rgb(138, 29, 150)",
      colorTextOnPrimaryBackground: "white",
    },

    elements: {
      profileSectionPrimaryButton__emailAddresses: {
        display: "none",
      },
    },
  },
  userButton: {
    action__addAccount: "Switch account",
  },
} as const;
